export default __webpack_public_path__ + "static/media/infographic.357bb2ff.png";